module.exports = __webpack_public_path__ + "img/qr.27233bfc.png";